import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden bg-petrol" data-id="element-147">
      {/* Tech-forward circuit background */}
      <div className="absolute inset-0 bg-circuit opacity-50 pointer-events-none" data-id="element-148"></div>

      {/* Turquoise glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-turquoise/10 rounded-full blur-[120px] pointer-events-none" data-id="element-149"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-151">
          <span className="inline-flex items-center gap-2 py-1 px-3 rounded-full bg-petrol-light border border-turquoise/30 text-turquoise text-xs font-semibold tracking-widest uppercase mb-6 shadow-[0_0_10px_rgba(0,212,170,0.1)]" data-id="element-152">
            <span className="w-1.5 h-1.5 rounded-full bg-turquoise animate-pulse" data-id="element-153"></span>
            Autoridad Digital para Especialistas de Salud
          </span>

          <h1 className="text-5xl md:text-7xl font-bold leading-tight mb-6" data-id="element-154">
            Transformamos su Clínica en una{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-turquoise to-turquoise-light" data-id="element-155">
              Institución de Autoridad.
            </span>
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-silver max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-156">
          Desarrollamos infraestructuras digitales diseñadas para atraer
          pacientes de alto valor. Deje de ser invisible en Google y domine su
          mercado local.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-157">
          <a href="https://wa.me/50672642898" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-turquoise hover:bg-turquoise-hover text-petrol font-bold text-base px-8 py-4 rounded transition-all hover:shadow-[0_0_20px_rgba(0,212,170,0.4)]" data-id="element-158">
            Solicitar Auditoría Gratis
            <ArrowRightIcon className="w-5 h-5" data-id="element-159" />
          </a>
          <a href="#servicios" className="w-full sm:w-auto flex items-center justify-center px-8 py-4 rounded text-white font-medium border border-petrol-lighter hover:bg-petrol-light hover:border-turquoise/30 transition-colors" data-id="element-160">
            Ver Servicios
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.6,
        ease: 'easeOut'
      }} className="mt-16 relative max-w-4xl mx-auto" data-id="element-161">
          <div className="relative rounded-2xl overflow-hidden border border-turquoise/20 shadow-[0_20px_60px_-20px_rgba(0,212,170,0.25)]" data-id="element-162">
            <img src="https://images.unsplash.com/photo-1581595220892-b0739db3ba8c?auto=format&fit=crop&w=1600&q=80" alt="Consultorio médico premium con tecnología digital" className="w-full h-[280px] md:h-[400px] object-cover" data-id="element-163" />
            {/* Petrol tint overlay to integrate with the dark theme */}
            <div className="absolute inset-0 bg-gradient-to-t from-petrol via-petrol/40 to-transparent" data-id="element-164"></div>
            <div className="absolute inset-0 bg-petrol/30 mix-blend-multiply" data-id="element-165"></div>
            {/* Circuit accent overlay */}
            <div className="absolute inset-0 bg-circuit opacity-20 pointer-events-none" data-id="element-166"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}